<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe-row" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char20">
                <label v-if="ckSequencialEdit" class="label-link" @click="abrirModalSequencial">Protocolo</label>
                <label v-else class="label-caption">Protocolo</label>
                <div class="field-label field-label-center field-label--destaque">{{ docView?.protocolo }}</div>
            </div>

            <div class="form-item-char40">
                <label class="label-caption">Documento</label>
                <div class="field-label field-label--destaque">{{ docView?.nmepdocmodelo }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">S.I.M.</label>
                <div class="field-label field-label--destaque">{{ docView?.nmsim }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label field-label--destaque">{{ docView?.nmestabelecimento }}</div>
            </div>
        </div>

        <div class="row-start row-space">
            <div class="form-item-data">
                <label class="label-caption">Data</label>
                <input type="date" v-model="docEdit.dtdoc" />
            </div>
            
            <div class="form-item-char10">
                <label class="label-caption">Hora</label>
                <input class="input-center" v-model="docEdit.hrdoc" v-time />
            </div>
            
            <div class="form-item">
                <label class="label-caption">Assunto / Identificação do formulário</label>
                <input v-model="docEdit.nmreferencia" maxlength="200"
                    placeholder="Informe resumidamente o assunto ou a atividade realizada"
                />
            </div>

            <button v-if="docView.ckanexo === 'S'" class="btn-small" @click="showAnexo = !showAnexo">{{ showAnexo ? 'Ítens' : 'Anexos' }}</button>
            <button v-if="docView.cdstatus === 1" class="btn-small" @click="salvarDados(false)">Salvar</button>
            <button v-if="!docView.idlaudo" class="btn-small" @click="visualizarEmissao">Visualizar</button>
            <button v-if="docView.cdstatus===1" class="btn-small" @click="salvarDados(true)">Encerrar</button>
            <button v-if="docView.cdstatus===1" class="btn-small btn-delete" @click="excluirDoc">Excluir</button>
            <button class="btn-small" @click="closePage">Retornar</button>
        </div>
    </div>


    <div v-show="!showAnexo" class="form-edit-page">
        <DynamicDocRenderer v-model:itens="lsItens" :opcoes-api="lsOpcoes" />
    </div>
    <div v-show="showAnexo">
        <div class="form-edit-page row-space">
            <div class="row row-space">   
                <div class="form-item">
                    <AnexoUploadField ref="uploaderRef" :maxSizeMB="20" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome/Identificação</label>
                    <input type="text" v-model="anexoNm" maxlength="100" v-uppercase />
                </div>

                <button class="btn-small" @click="salvarAnexo">Enviar</button>
            </div>
        </div>


        <div class="form-edit-page row-space">
            <AnexoGrid
                titulo="Anexos vinculados"
                :anexos="lsAnexos"
                :permite-remover="true"
                @remover="removerAnexo"
            />
        </div>
    </div>


    <SenhaModal ref="senhaModalRef" />


    <ModalNumero
        v-model="modalSequencial"
        header="Informe o Novo Sequencial"
        @confirmar="redefinirSequencial"
    />


    <ModalVincularAssinaturas
        v-if="showModalAssinaturas"
        :idSim="docView.idsim"
        :idEstabelecimento="docView.idestabelecimento"
        :idUsuario="globalStore.idusuario"
        :permitirOutros="!globalStore.showAcoesEstabelecimento"
        :tituloForm="`Encerramento: ${docView.nmepdocmodelo}`"
        :referencia="{
            titulo: docView.nmepdocmodelo,
            tabela: 'DOC',
            id: docView.id,
            protocolo: docView.protocolo
        }"
        @save="confirmarEncerramento()"
        @close="showModalAssinaturas=false"
    />

    
    <ModalJustificativa ref="modalJustificativa" />
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAssinatura } from '@/models/assinatura';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { itemPrecisaInformacao } from '@/components/doc/docUtils';
import { Validar } from '@/funcoes/validacoes';
import AnexoGrid from '@/components/anexos/AnexoGrid.vue';
import AnexoUploadField from '@/fields/AnexoUploadField.vue';
import DynamicDocRenderer from '@/components/doc/DynamicDocRenderer.vue';
import ModalJustificativa from '@/components/modals/ModalJustificativa.vue';
import ModalNumero from '@/components/modals/ModalNumero.vue';
import ModalVincularAssinaturas from '@/components/modals/ModalVincularAssinaturas.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';

const emit = defineEmits(['close','save'])
const props = defineProps({idEdicao: {type: Number, default: 0}})
const senhaModalRef = ref(null);
const modalSequencial = ref(false);
const showAnexo = ref(false);
const showModalAssinaturas = ref(false);
const modalJustificativa = ref(null);

const ckSequencialEdit = ref(false);
const docView = ref({});
const docEdit = reactive({id: 0, dtdoc: '', hrdoc: '', nmreferencia: '', idlogin: 0}); // NÃO USAR "protocolo_sequencia" DEVIDO ATRIBUIÇÃO EM SEPARADO

const lsAnexos = ref([]);
const lsItens = ref([]);
const lsOpcoes = ref([]);

const isLoading = ref(false);
const msgAlerta = ref(null);

const anexoNm = ref(null);
const uploaderRef = ref(null);


function abrirModalSequencial() {
    if (!docView.value.idlaudo) modalSequencial.value = true;
}


function closePage(emiSave = false) {
    if (emiSave) emit('save');
    emit('close');
}


async function confirmarEncerramento(){
    // 27-06-2026: FUNÇÃO CHAMADA APÓS CONFIRMAR ASSINATURAS NECESSÁRIAS; SETAR STATUS DO DOC; SOLICITAR ASSINATURA SE VINCULADA AO USUÁRIO
    docView.value.cdstatus=2; // MÉTODO QUE USEI PARA CASO ERRO DE SENHA NÃO REABRIR E SOLICITAR NOVAMENTE ASSINATURAS
    
    try{
        isLoading.value = true;
        await Api.genericPut('/cad/doc', {
            id: docView.value.id,
            idlgfim: globalStore.idlogin,
            idlogin: globalStore.idlogin
        });

        const req = await Api.genericPost('/dados/assinatura/pendencia', {
            idep: globalStore.idep,
            intparam1: 1,
            intparam2: globalStore.idusuario,
            strparam1: 'DOC',
            idreferencia: docView.value.id,
        });

        const pendencia = Array.isArray(req) ? req[0] : null;

        if (pendencia?.id != null) {
            const senhaDigitada = await senhaModalRef.value.showModal();
            if (!senhaDigitada) return;


            // REGISTRAR ASSINATURA
            const objAssinatura = criarAssinatura();
            objAssinatura.idep            = globalStore.idep;
            objAssinatura.idusuario       = globalStore.idusuario;
            objAssinatura.idsessao        = globalStore.idlogin;
            objAssinatura.nmusuario       = globalStore.nmusuario;
            objAssinatura.vssistema       = `${globalStore.appname} vs. ${globalStore.appver}`;
            objAssinatura.ass_conteudo    = `REF:DOC|IDREF:${docView.value.id}|PROT:${docView.value.protocolo}`;
            objAssinatura.ass_senha       = senhaDigitada;
            objAssinatura.ass_tipoauth    = 'senha pessoal via sistema WEB';
            objAssinatura.doc_idorigem    = docView.value.id;
            objAssinatura.doc_tipo        = 'DOC';
            objAssinatura.acao = 'registroAssinaturaPendente';
            objAssinatura.acao_id = pendencia.id;

            const respAss = await Api.genericPut('/doc/assinar', objAssinatura);

            if (respAss.bolok != 1) throw new Error(respAss.erro);
        }
        
        closePage(true);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


async function excluirDoc(){
    const rModal = await modalJustificativa.value.show();
    if (!rModal.confirmado) return;

    try {
        isLoading.value = true;
        const r = await Api.genericPost('/cad/exclusao', {
            id: docView.value.id,
            idep: globalStore.idep,
            strparam1: 'DOC',
            strparam2: `PROTOCOLO: ${docView.value.protocolo}; MODELO: ${docView.value.nmepdocmodelo}`,
            strparam3: rModal.justificativa,
            idlogin: globalStore.idlogin
        });
        if (r.bolok === 1){
            closePage(true);
        }else{
            msgAlerta.value = r.erro;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }

}


async function lerAnexos(){
    try{
        const reqAnexos = await Api.genericPost('/lsdoc/doc/anexos', {
            idep: globalStore.idep,
            idreferencia: props.idEdicao
        });
        lsAnexos.value = reqAnexos;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;}
}


async function redefinirSequencial(valor) {
    if (valor < 1) return;
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const response = await Api.genericPut('/cad/doc', {
            id: docEdit.id,
            protocolo_sequencia: valor,
            idlogin: globalStore.idlogin,
        });
        if (response.bolok===1){
            const req = await Api.genericPost('/lsdoc/doc', {idep: globalStore.idep, id: props.idEdicao});
            Object.assign(docView.value, req[0]);
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


async function salvarAnexo(){
    msgAlerta.value=null;
    let x = '';
    if (!uploaderRef.value?.hasFile()) x += '\n-Necessário selecionar um arquivo';
    let r = Validar.texto(anexoNm.value, '\n-Informe nome ou identificação do anexo');
    if (!r.ok) x += r.msg;
    if (x){
        msgAlerta.value = `ATENÇÃO:${x}`;
        return;
    }

    try{
        isLoading.value = true;
        const file = uploaderRef.value.getFile();
        const ext = (file.name.split('.').pop() || '').toLowerCase();
        const payloadAnexo = {
            idep: globalStore.idep,
            idanexogrupo: 8,
            idlogin: globalStore.idlogin,
            nmdoc: anexoNm.value,
            tipo: file.type === 'application/pdf' ? '0' : '1',
            fname: file.name,
            file_ext: ext,
            mime_type: file.type || 'application/octet-stream'
        };

        const ret = await uploaderRef.value.upload(payloadAnexo);
        const response = await Api.genericPost('/cad/exec_requisicao', {
            nmrequisicao: 'DOC_ANEXO',
            intparam1: docView.value.id,
            intparam2: ret.id,
            idlogin: globalStore.idlogin});
        if (response.bolok === 1){
            await lerAnexos();
        }else{
            msgAlerta.value = response.erro;
        }

        anexoNm.value = null;
        uploaderRef.value.clear();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function getItemPai(item) {
    if (!item.idpai) return null;

    return lsItens.value.find(i => Number(i.id) === Number(item.idpai)) || null;
}


async function lerDados(){
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/lsdoc/doc', {idep: globalStore.idep, id: props.idEdicao});
        Object.assign(docView.value, req[0]);

        if (docView.value.idlaudo){
            msgAlerta.value = 'ATENÇÃO: Esse formulário já foi encerrado e possui laudo emitido';
            return;
        }

        ckSequencialEdit.value = (docView.value.protocolo_sequencia === 1);
        docEdit.id = docView.value.id;
        docEdit.dtdoc = docView.value.dtdoc;
        docEdit.hrdoc = Funcoes.formatTimeFromJson(docView.value.hrdoc);
        docEdit.nmreferencia = docView.value.nmreferencia;
        docEdit.protocolo = docView.value.protocolo;
        docEdit.idlogin = globalStore.idlogin;


        const rOpcoes = await Api.genericPost('/listas/epdocopcoes/from/doc', {idep: globalStore.idep, idreferencia: props.idEdicao});
        lsOpcoes.value = rOpcoes;

        const reqItens = await Api.genericPost('/lsdoc/doc/itens', {idreferencia: props.idEdicao});
        lsItens.value = reqItens;

        await lerAnexos();

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value = false;}
}


async function removerAnexo(anexo) {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        
        await Api.genericPut('/cad/anexo', {
            idep: globalStore.idep,
            id: anexo.id,
            cancelamentoidlogin: globalStore.idlogin,
            cancelamentoobs: 'EXCLUÍDO PELA EDIÇÃO DO DOCUMENTO/FORMULÁRIO VINCULADO'
        });

        await lerAnexos();

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value = false;}
}


async function salvarDados(ckEncerramento = false){
    if (ckEncerramento){
        msgAlerta.value = validarDados();
        if (msgAlerta.value) return;
    }

    try {
        isLoading.value = true;
        const response = await Api.genericPut('/cad/doc', docEdit);
        if (response.bolok === 1){
            // TODO: SALVAR OS ÍTENS
            for (const item of lsItens.value) {
                if (item.tpresposta === 'CHECK_SN' && !item.resposta_opcoes){
                    item.resposta_opcoes = 'N';
                }
                const ri = await Api.genericPut('/cad/doc_item',{
                    id: item.id,
                    cdpai_opcoes: item.cdpai_opcoes,
                    resposta_data: item.resposta_data,
                    resposta_numero: item.resposta_numero,
                    resposta_opcoes: item.resposta_opcoes,
                    resposta_opcoes_cditem: item.resposta_opcoes_cditem,
                    resposta_texto: item.resposta_texto,
                    resposta_memo: item.resposta_memo,
                    informacoes: item.informacoes,
                    idlogin: globalStore.idlogin
                });
                if (ri.bolok != 1){msgAlerta.value = ri.erro; return;}
            }
            if (ckEncerramento) showModalAssinaturas.value=true;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error) {msgAlerta.value = error;
    } finally{isLoading.value=false;}
}


function validarDados(){
    let x = '';
    let r = Validar.texto(docEdit.protocolo, '\n-Informe identificação do protocolo');
    if (!r.ok) x += r.msg;
    r = Validar.data(docEdit.dtdoc, -180);
    if (!r.ok) x += '\n-Verifique a data do documento';

    // VALIDAÇÃO DOS ÍTENS
    for (const item of lsItens.value) {
        if (item.ckobrigatorio === 'S' && item.tpresposta !== 'CHECK_SN') {
            let valor = null;

            if (item.tpresposta === 'FIELD') {
                if (item.tpfield === 'DATA') valor = item.resposta_data;
                else if (item.tpfield === 'NUMERO') valor = item.resposta_numero;
                else valor = item.resposta_texto;
            }

            if (item.tpresposta === 'MEMO') {
                valor = item.resposta_memo;
            }

            if (
                item.tpresposta === 'CHECK' ||
                item.tpresposta === 'RADIO' ||
                item.tpresposta === 'RADIO_GROUP' ||
                item.tpresposta === 'SELECT'
            ) {
                valor = item.resposta_opcoes;
            }

            if (valor === null || valor === undefined || String(valor).trim() === '') {
                x += `\n-Informe: ${item.nmcaption}`;
            }
        }

        const itemPai = getItemPai(item);
        const opcoesCkObsPadrao = item.opcoes_ckobs || itemPai?.opcoes_ckobs || null;

        if (itemPrecisaInformacao(item, opcoesCkObsPadrao)) {
            if (!item.informacoes || String(item.informacoes).trim() === '') {
                x += `\n-Informe as informações complementares: ${item.nmcaption}`;
            }
        }
    }

    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}


async function visualizarEmissao(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: docView.value.nmrelatorio,
            id: docView.value.id,
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idusuario: globalStore.idusuario
        };
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


onMounted(lerDados)
</script>